export default __webpack_public_path__ + "static/AppBeers1-34400abfb396b605a9ba093035f54e19.png";